import { Component, Input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-password-requirements",
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: "./password-requirements.component.html",
  styleUrl: "./password-requirements.component.css",
})
export class PasswordRequirementsComponent {
  @Input() validations = {
    minLength: false,
    uppercase: false,
    number: false,
    specialChar: false,
  };
}
